import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function GiftCardValoresGridFallback() {
  return (
    <div
      style={{
        display: 'grid',
        gap: theme.spacing[4],
        gridTemplateColumns: 'repeat(2, 1fr)',
      }}
    >
      {Array.from({ length: 7 }).map((item, index) => (
        <Skeleton
          key={`${item}_${index}`}
          style={{
            height: 80,
            ...(index === 6 ? { gridColumn: 'span 2' } : {}),
          }}
        />
      ))}
    </div>
  );
}
